import { render } from "./Loader.vue?vue&type=template&id=547da6e9&scoped=true"
import script from "./Loader.vue?vue&type=script&lang=js"
export * from "./Loader.vue?vue&type=script&lang=js"

import "./Loader.vue?vue&type=style&index=0&id=547da6e9&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-547da6e9"

export default script